import { Check, Clock, ShieldCheck } from "lucide-react";
import { APPS } from "@/config";

const [APP1] = APPS;

const EVENTS = [
  { t: "Deal received", d: `via ${APP1.buyerName}`, s: "done" },
  { t: "Playbook matched", d: "Incentive playbook applied to the deal", s: "done" },
  { t: "Offer drafted", d: "Offer and authorization ready for review", s: "done" },
  { t: "Awaiting approval", d: "Human gate — nothing releases until you approve", s: "current" },
  { t: "Released", d: "Sent to the buyer for acceptance", s: "pending" },
  { t: "Accepted", d: "Closed with a signed audit trail", s: "pending" },
];

export default function OfferTimeline() {
  return (
    <div
      data-testid="offer-timeline"
      className="rounded-2xl border border-line bg-white p-6 sm:p-8"
    >
      <div className="flex items-center justify-between">
        <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-ink">
          Offer timeline
        </p>
        <span className="rounded-full border border-line bg-paper px-3 py-1 font-mono text-[9px] uppercase tracking-[0.14em] text-inksoft">
          Live deal view
        </span>
      </div>

      <div className="mt-6">
        {EVENTS.map((e, i) => (
          <div key={e.t} className="relative flex gap-4 pb-5 last:pb-0">
            {i < EVENTS.length - 1 ? (
              <span
                className={`absolute left-[11px] top-7 h-[calc(100%-14px)] w-px ${
                  e.s === "pending" ? "bg-line" : "bg-bluerule"
                }`}
              />
            ) : null}
            <span
              className={`relative z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${
                e.s === "done"
                  ? "border-vermillion bg-vermillion text-white"
                  : e.s === "current"
                    ? "border-vermillion bg-vermillion-tint text-vermillion"
                    : "border-line bg-paper"
              }`}
            >
              {e.s === "done" ? (
                <Check size={12} strokeWidth={3} />
              ) : e.s === "current" ? (
                <Clock size={12} />
              ) : (
                <span className="h-1.5 w-1.5 rounded-full bg-line" />
              )}
            </span>
            <span className="flex-1">
              <span
                className={`flex items-center gap-2 text-sm font-semibold ${
                  e.s === "pending" ? "text-inksoft/60" : "text-ink"
                }`}
              >
                {e.t}
                {e.s === "current" ? (
                  <span className="relative flex h-1.5 w-1.5">
                    <span className="absolute h-full w-full animate-ping rounded-full bg-vermillion opacity-60" />
                    <span className="relative h-1.5 w-1.5 rounded-full bg-vermillion" />
                  </span>
                ) : null}
              </span>
              <span className="mt-0.5 block text-xs leading-relaxed text-inksoft">{e.d}</span>
            </span>
          </div>
        ))}
      </div>

      <div className="mt-6 flex items-center gap-2 border-t border-line pt-4">
        <ShieldCheck size={14} className="shrink-0 text-vermillion" />
        <p className="font-mono text-[9px] uppercase tracking-[0.16em] text-inksoft">
          Every event signed · full audit trail
        </p>
      </div>
    </div>
  );
}
